import app from '../store/modules/app';

class Api {

  mandate() {
    return app.state.mandate;
  }

  URL(path) {
    return `/api/mandates/${this.mandate()}/${path}`;
  }
}

const api = new Api();

export default api;
